<cm-page #cmPage>
  <cm-page-tab label="{{title}}">
    <div class="scrollContents">
      <h1>{{title}}</h1>
      <cm-text>{{message}}</cm-text>
    </div>
  </cm-page-tab>
</cm-page>
